import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPUnitTypeDDL } from '../../../../../Components/CommonDDL/STPUnitTypeDDL';
import { STPEquipmentTypePostDataAPI } from '../../../../../Redux/STPDashboardSlice/STPSidebarMaster/STPEquipmentTypeSlice';


export default function STPEquipmentTypeMasterPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // const [rowData, setRowData] = useState(item)

    // const [UnitType, setUnitType] = useState({
    //     DDL: [],
    //     ID: Flag === 'Update' ? rowData.m_ZoneID : 0,
    //     Label: Flag === 'Update' ? rowData.zoneName : "Select...",
    // })

    const [UnitType, setUnitType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [EquipmentType, setEquipmentType] = useState(Flag === 'Update' ? rowData.equipmentType : '')


    const handlePost = () => {
        const data = {
            M_STP_EquipmentTypeID: Flag === 'Update' ? rowData.m_stP_EquipmentTypeID : '0',
            M_STP_UnitTypeID: UnitType.ID,
            EquipmentType: EquipmentType,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(STPEquipmentTypePostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Equipment Type Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    {/* <ZoneDataDDLS
                                        ZoneName={ZoneName}
                                        setZoneName={setZoneName}
                                        rowData={rowData}
                                        Flag={Flag}
                                    /> */}
                                    <STPUnitTypeDDL
                                        UnitType={UnitType}
                                        setUnitType={setUnitType}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />


                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Type </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="EquipmentType"
                                            value={EquipmentType}
                                            onChange={(e) => setEquipmentType(e.target.value)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            UnitType.ID == 0 || EquipmentType == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}